var map = {
	"./2023/autumn/poster/best_game.png": "e9d4",
	"./2023/summer/poster/best_game.png": "6e50",
	"./2024/autumn/poster/best_game.png": "73a2",
	"./2024/summer/poster/best_game.png": "ea9b",
	"./2024/winter/poster/best_game.png": "e1dc",
	"./2025/spring/poster/best_game.png": "1514",
	"./2025/summer/poster/best_game.png": "cd8a",
	"./2025/winter/poster/best_game.png": "a1ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abe6";